import { render, staticRenderFns } from "./OrderToggleablePropsButton.vue?vue&type=template&id=66c1ec65&scoped=true"
import script from "./OrderToggleablePropsButton.vue?vue&type=script&lang=js"
export * from "./OrderToggleablePropsButton.vue?vue&type=script&lang=js"
import style0 from "./OrderToggleablePropsButton.vue?vue&type=style&index=0&id=66c1ec65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c1ec65",
  null
  
)

export default component.exports